// extracted by mini-css-extract-plugin
module.exports = {"dialog":"FullScreenDialog_dialog__2kir7","appBar":"FullScreenDialog_appBar__2PdOM","title":"FullScreenDialog_title__3_iyu"};